// extracted by mini-css-extract-plugin
export var card = "_8q-1";
export var container = "_8q-0";